export const FORM_RESOURCE_TYPES = {
  checkbox: 'vaa-home/components/form/checkbox',
  checkboxGroup: 'vaa-home/components/form/checkbox-group',
  container: 'vaa-home/components/form/container',
  datePicker: 'vaa-home/components/form/date-picker',
  fieldRow: 'vaa-home/components/form/field-row',
  fileUpload: 'vaa-home/components/form/file-upload',
  radio: 'vaa-home/components/form/radio',
  radioGroup: 'vaa-home/components/form/radio-group',
  repeater: 'vaa-home/components/form/repeater',
  select: 'vaa-home/components/form/select',
  switch: 'vaa-home/components/form/switch',
  textArea: 'vaa-home/components/form/text-area',
  textInput: 'vaa-home/components/form/text-input',
  textLockup: 'vaa-home/components/text-lockup-component',
} as const;

export type FormResourceType =
  (typeof FORM_RESOURCE_TYPES)[keyof typeof FORM_RESOURCE_TYPES];

export const FORM_CONTAINER_COMPONENT_TYPE = 'form-container';

/** Display styles exported by the AEM Form Select component. */
export const FORM_SELECT_DISPLAY_STYLES = {
  searchable: 'searchable',
  standard: 'standard',
} as const;

export const FORM_PROPERTY_NAMES = {
  aemItems: ':items',
  aemItemsOrder: ':itemsOrder',
  items: 'items',
  itemsOrder: 'itemsOrder',
  validationContentFragments: 'validationContentFragments',
} as const;

export const FORM_INTERNAL_PROPERTY_NAMES = {
  renderKey: '__formRenderKey',
} as const;

export type FormRenderableFieldResourceType = Exclude<
  FormResourceType,
  typeof FORM_RESOURCE_TYPES.container | typeof FORM_RESOURCE_TYPES.textLockup
>;
